import { memo, useMemo } from "react";
import {
  convertTipTapToHTML,
  isRichTextContent,
} from "../../utils/richTextHelpers";
import type { TextRendererProps } from "./TextRenderer.types";

export const StaticTextRenderer = memo(
  ({ text, className, placeholder }: TextRendererProps) => {
    const htmlContent = useMemo(() => {
      if (isRichTextContent(text)) {
        return convertTipTapToHTML(text);
      }
      return null;
    }, [text]);

    if (htmlContent) {
      return (
        <div
          className={className}
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      );
    }

    if (!isRichTextContent(text)) {
      return <span className={className}>{text || placeholder || ""}</span>;
    }

    return null;
  },
);

StaticTextRenderer.displayName = "StaticTextRenderer";
